import { render, staticRenderFns } from "./Horoscope.vue?vue&type=template&id=0036c940&scoped=true&"
import script from "./Horoscope.vue?vue&type=script&lang=js&"
export * from "./Horoscope.vue?vue&type=script&lang=js&"
import style0 from "./Horoscope.vue?vue&type=style&index=0&id=0036c940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036c940",
  null
  
)

export default component.exports